import React from 'react';
import { useParams, Link } from 'react-router-dom';

const ProjectDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  // TODO: Înlocuiește cu date reale din API
  const project = {
    id: id,
    title: 'Digitalizare SME',
    description: 'Căutăm consultant pentru digitalizarea proceselor companiei și implementarea unui sistem ERP. Proiectul presupune analiza proceselor actuale, identificarea oportunităților de îmbunătățire și implementarea soluțiilor tehnologice necesare.',
    category: 'IT',
    location: 'București',
    budget: 50000,
    requirements: [
      'Experiență minimă 5 ani în consultanță IT',
      'Cunoaștere profundă a proceselor de business',
      'Experiență în implementare ERP',
      'Certificări relevante în domeniu'
    ],
    deadline: '2024-12-31',
    tags: ['digitalizare', 'ERP', 'consultanță', 'IT'],
    status: 'open',
    createdAt: '2024-03-15',
    client: {
      name: 'Tech Solutions SRL',
      rating: 4.8,
      projectsCompleted: 12
    }
  };

  return (
    <div className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="bg-white rounded-lg shadow-md p-6 mb-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mr-4">
                  <span className="text-primary font-semibold">{project.category}</span>
                </div>
                <div>
                  <h1 className="text-2xl font-bold">{project.title}</h1>
                  <p className="text-gray-500">{project.location}</p>
                </div>
              </div>
              <div className="text-right">
                <div className="text-2xl font-bold text-primary">{project.budget}€</div>
                <div className="text-sm text-gray-500">Buget</div>
              </div>
            </div>

            <div className="flex flex-wrap gap-2 mb-4">
              {project.tags.map((tag, index) => (
                <span
                  key={index}
                  className="px-3 py-1 bg-primary/10 text-primary rounded-full text-sm"
                >
                  {tag}
                </span>
              ))}
            </div>

            <div className="flex items-center justify-between text-sm text-gray-500">
              <div>Publicat: {new Date(project.createdAt).toLocaleDateString('ro-RO')}</div>
              <div>Termen limită: {new Date(project.deadline).toLocaleDateString('ro-RO')}</div>
            </div>
          </div>

          {/* Content */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="space-y-6">
              {/* Descriere */}
              <div>
                <h2 className="text-xl font-semibold mb-3">Descriere Proiect</h2>
                <p className="text-gray-600 whitespace-pre-line">{project.description}</p>
              </div>

              {/* Cerințe */}
              <div>
                <h2 className="text-xl font-semibold mb-3">Cerințe</h2>
                <ul className="space-y-2">
                  {project.requirements.map((req, index) => (
                    <li key={index} className="flex items-start">
                      <svg className="w-5 h-5 text-primary mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="text-gray-600">{req}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Client */}
              <div>
                <h2 className="text-xl font-semibold mb-3">Despre Client</h2>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="font-semibold">{project.client.name}</h3>
                      <div className="flex items-center mt-1">
                        <div className="flex items-center text-yellow-400">
                          {[...Array(5)].map((_, i) => (
                            <svg key={i} className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                            </svg>
                          ))}
                        </div>
                        <span className="ml-2 text-sm text-gray-600">{project.client.rating}/5</span>
                      </div>
                      <p className="text-sm text-gray-600 mt-1">{project.client.projectsCompleted} proiecte finalizate</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="pt-6 border-t">
                <div className="flex gap-4">
                  <Link
                    to="/autentificare"
                    className="flex-1 py-3 bg-primary text-white text-center rounded-lg hover:bg-primary-dark transition-colors"
                  >
                    Aplică la Proiect
                  </Link>
                  <Link
                    to="/projects"
                    className="flex-1 py-3 bg-white text-primary border border-primary text-center rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    Înapoi la Proiecte
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails; 